import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";

import Landing from "@/pages/Landing";
import Portfolio from "@/pages/Portfolio";
import CaseStudy from "@/pages/CaseStudy";
import Services from "@/pages/Services";
import Booking from "@/pages/Booking";
import OrderFlow from "@/pages/OrderFlow";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ClientDashboard from "@/pages/ClientDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Settings from "@/pages/Settings";

function AppShell() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [location.pathname]);

  // Handle the OAuth callback before rendering the application shell.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const bare = ["/login", "/signup"].includes(location.pathname);
  return (
    <div className="App min-h-screen flex flex-col">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      {!bare && <Navbar />}
      <main id="main-content" className="flex-1" tabIndex="-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:itemId" element={<CaseStudy />} />
          <Route path="/services" element={<Services />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/order" element={<ProtectedRoute><OrderFlow /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><ClientDashboard /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute roles={["super_admin","designer","developer","marketing","sales"]}><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute roles={["super_admin"]}><Settings /></ProtectedRoute>} />
          <Route path="*" element={
            <div className="page-container py-24 text-center" data-testid="not-found-page">
              <div className="label-mono mb-3">404 · Wrong turn</div>
              <h1 className="font-display font-semibold text-4xl sm:text-6xl">This page doesn’t exist.</h1>
              <p className="text-white/60 mt-4">The work is still here. Let’s get you back to it.</p>
              <a href="/" className="pill-btn accent mt-8">Return home</a>
            </div>
          } />
        </Routes>
      </main>
      {!bare && <Footer />}
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </AuthProvider>
  );
}
export default App;
